import React, { useLayoutEffect } from "react";
import { Link } from "react-router-dom";
import "../components/styles/common.css";
import Footer from "../components/ui/Footer";
import NavbarHome from "../components/ui/NavbarHome";

const PrivacyPolicy = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <div className="h-full font-nunito">
      <NavbarHome />
      <div className="flex justify-center mt-24 flex-col px-8 lg:px-48 gap-3 text-lg py-8">
        <h1 className="text-3xl font-extrabold text-center mb-8">
          Privacy Policy
        </h1>

        <h1 className="text-2xl font-bold mt-3">Introduction</h1>
        <p className="w-full">
          Welcome to ScopeX, a service provided by Dviz Limited ("we", "us",
          "our"). ScopeX is a remittance platform that harnesses the power of
          blockchain technology to provide seamless, efficient, and
          cost-effective money transfer services. Our registered office is at
          128, City Road, London, EC1V 2NX, UK, and our company registration
          number is 14819550.
        </p>
        <p className="w-full">
          At ScopeX, we understand the importance of your privacy and are
          committed to protecting your personal data. This Privacy Policy will
          inform you as to how we look after your personal data when you visit
          our website (regardless of where you visit it from) or use our mobile
          applications, and tell you about your privacy rights and how the law
          protects you.
        </p>
        <p className="w-full">
          This Privacy Policy aims to give you information on how ScopeX
          collects and processes your personal data through your use of our
          platform, including any data you may provide through the platform when
          you sign up, use our services, or communicate with us.
        </p>
        <p className="w-full">
          It is important that you read this Privacy Policy together with any
          other privacy notice or fair processing notice we may provide on
          specific occasions when we are collecting or processing personal data
          about you so that you are fully aware of how and why we are using your
          data. This Privacy Policy supplements the other notices and is not
          intended to override them.
        </p>

        <h1 className="text-2xl font-bold mt-3">What Information We Collect</h1>
        <p className="w-full">
          In order to provide our services, we need to collect certain types of
          information. The types of information we collect can be categorized as
          follows:
        </p>
        <p className="w-full">
          <ul className="list-disc list-inside">
            <li>
              Personal Identification Information: This includes information
              that can be used to identify you as an individual. Examples
              include your name, email address, phone number, postal address,
              and date of birth.
            </li>
            <li>
              Transactional Data: This includes details about payments to and
              from you, and other details of products and services you have
              purchased from us. This may also include information related to
              your financial transactions, such as your bank account details,
              payment card details, and details about your trading activities.
            </li>
            <li>
              Technical Data: This includes information we collect from your
              devices as you use our platform. Examples include your Internet
              Protocol (IP) address, your login data, browser type and version,
              time zone setting and location, browser plug-in types and
              versions, operating system and platform, and other technology on
              the devices you use to access our platform.
            </li>
            <li>
              Communication Data: This includes information related to your
              communication preferences, your customer service interactions with
              us, and your feedback.
            </li>
            <li>
              Usage Data: This includes information about how you use our
              website, products, and services. This could include your browsing
              patterns, the pages you visit, and the links you click on.
            </li>
            <li>
              Marketing and Communications Data: This includes your preferences
              in receiving marketing from us and our third parties and your
              communication preferences.
            </li>
          </ul>
        </p>
        <p className="w-full">
          Please note that we do not collect any Special Categories of Personal
          Data about you (this includes details about your race or ethnicity,
          religious or philosophical beliefs, sex life, sexual orientation,
          political opinions, trade union membership, information about your
          health, and genetic and biometric data). Nor do we collect any
          information about criminal convictions and offences.
        </p>
        <h1 className="text-2xl font-bold mt-3">How We Collect Information</h1>
        <p className="w-full">
          We use different methods to collect data from and about you including
          through:
        </p>
        <p className="w-full">
          <ul className="list-disc list-inside">
            <li>
              Direct Interactions: You may give us your personal identification,
              transactional, and communication data by filling in forms or by
              corresponding with us by post, phone, email, or otherwise. This
              includes personal data you provide when you:
              <ul className="list-disc list-inside">
                <li>Create an account on our platform</li>
                <li>Subscribe to our service or publications</li>
                <li>Request marketing to be sent to you</li>
                <li>Enter a competition, promotion, or survey</li>
                <li>Give us feedback or contact us</li>
              </ul>
            </li>
            <li>
              Automated Technologies or Interactions: As you interact with our
              platform, we may automatically collect technical data about your
              equipment, browsing actions, and patterns. We collect this
              personal data by using cookies, server logs, and other similar
              technologies.
            </li>
            <li>
              Third Parties or Publicly Available Sources: We may receive
              personal data about you from various third parties and public
              sources as set out below:
              <ul className="list-disc list-inside">
                <li>
                  Technical Data from analytics providers such as Google based
                  outside the EU
                </li>
                <li>
                  Contact, Financial and Transaction Data from providers of
                  technical, payment, and delivery services
                </li>
                <li>
                  Identity and Contact Data from data brokers or aggregators
                </li>
                <li>
                  Identity and Contact Data from publicly available sources such
                  as Companies House and the Electoral Register based inside the
                  EU
                </li>
              </ul>
            </li>
          </ul>
        </p>

        <h1 className="text-2xl font-bold mt-3">How We Use Your Information</h1>
        <p className="w-full">
          We use the information we collect from you in several ways. These
          include:
        </p>
        <p className="w-full">
          <ul className="list-disc list-inside">
            <li>
              To Register You as a New Customer: We use your personal
              identification information to create your account and register you
              as a new customer.
            </li>
            <li>
              To Process and Deliver Your Transactions: We use your
              transactional data to process transactions, send money, manage
              payments, fees, and charges, and collect and recover money owed to
              us.
            </li>
            <li>
              To Manage Our Relationship with You: This includes notifying you
              about changes to our terms or privacy policy, asking you to leave
              a review or take a survey, and enabling you to partake in a prize
              draw, competition, or complete a survey.
            </li>
            <li>
              To Improve Our Platform, Products/Services, Marketing, or Customer
              Relationships: We use your personal data to improve our platform
              and provide you with a better user experience. This could include
              troubleshooting, data analysis, testing, system maintenance,
              support, reporting, and hosting of data.
            </li>
            <li>
              To Recommend Products or Services Which May Be of Interest to You:
              We use your data to suggest products or services that might
              interest you, and to show you relevant advertisements.
            </li>
            <li>
              To Comply with Legal Obligations: We may process your personal
              data when we need to comply with a legal or regulatory obligation.
            </li>
          </ul>
        </p>
        <p className="w-full">
          Please note that we only use your personal data when the law allows us
          to. Most commonly, we will use your personal data where we need to
          perform the contract we are about to enter into or have entered into
          with you, where it is necessary for our legitimate interests (or those
          of a third party) and your interests and fundamental rights do not
          override those interests, or where we need to comply with a legal
          obligation.
        </p>
        <h1 className="text-2xl font-bold mt-3">
          How We Share Your Information
        </h1>
        <p className="w-full">
          We may have to share your personal data with the parties set out below
          for the purposes set out in the paragraph above ("How We Use Your
          Information"):
        </p>
        <p className="w-full">
          <ul className="list-disc list-inside">
            <li>
              Internal Third Parties: Other companies in the Dviz Limited group
              acting as joint controllers or processors and who are based in the
              EU provide IT and system administration services and undertake
              leadership reporting.
            </li>
            <li>
              External Third Parties Service: Service providers (vendors) acting
              as processors based in and outside of the EU who provide IT and
              system administration services, financial transaction processing
              services, customer service, marketing efforts, and other business
              operations.
            </li>
            <li>
              Specific Vendors: We may share your personal data with specific
              vendors that we partner with to provide certain services, such as
              money on and off-ramp services.
            </li>
            <li>
              Potential Business Partners or Buyers: We may choose to sell,
              transfer, or merge parts of our business or our assets with other
              businesses. Alternatively, we may seek to acquire other businesses
              or merge with them. If a change happens to our business, then the
              new owners may use your personal data in the same way as set out
              in this privacy policy.
            </li>
          </ul>
        </p>
        <p className="w-full">
          We require all third parties to respect the security of your personal
          data and to treat it in accordance with the law. We do not allow our
          third-party service providers to use your personal data for their own
          purposes and only permit them to process your personal data for
          specified purposes and in accordance with our instructions.
        </p>

        <h1 className="text-2xl font-bold mt-3">
          How We Protect Your Information
        </h1>
        <p className="w-full">
          The security of your personal data is of utmost importance to us. We
          have put in place appropriate security measures to prevent your
          personal data from being accidentally lost, used, or accessed in an
          unauthorized way, altered, or disclosed. In addition, we limit access
          to your personal data to those employees, agents, contractors, and
          other third parties who have a business need to know. They will only
          process your personal data on our instructions, and they are subject
          to a duty of confidentiality.
        </p>
        <p className="w-full">
          We have put in place procedures to deal with any suspected personal
          data breach and will notify you and any applicable regulator of a
          breach where we are legally required to do so.
        </p>
        <p className="w-full">
          Our security measures include encryption of your data, security
          assessments of all service providers who may handle your personal
          data, regular planning to ensure we are ready to respond to cyber
          security attacks and data security incidents, and regular testing of
          our technology and ways of working, including disaster recovery and
          incident response drills.
        </p>
        <h1 className="text-2xl font-bold mt-3">International Transfers</h1>
        <p className="w-full">
          ScopeX operates on a global scale which means it may be necessary to
          transfer your personal data internationally. In particular, your
          personal data may be transferred to and processed in countries outside
          the European Economic Area (EEA). These countries may have data
          protection laws that are different to the laws of your country.
        </p>
        <p className="w-full">
          However, we have taken appropriate safeguards to require that your
          personal data will remain protected in accordance with this Privacy
          Policy. These include implementing the European Commission’s Standard
          Contractual Clauses for transfers of personal data between our group
          companies, which require all group companies to protect personal data
          they process from the EEA in accordance with European Union data
          protection law.
        </p>
        <p className="w-full">
          Our Standard Contractual Clauses can be provided on request. We have
          implemented similar appropriate safeguards with our third-party
          service providers and partners and further details can be provided
          upon request.
        </p>

        <h1 className="text-2xl font-bold mt-3">Your Legal Rights</h1>
        <p className="w-full">
          Under certain circumstances, you have rights under data protection
          laws in relation to your personal data. These include the right to:
        </p>
        <p className="w-full">
          <ul className="list-disc list-inside">
            <li>
              Request access to your personal data: This enables you to receive
              a copy of the personal data we hold about you and to check that we
              are lawfully processing it.
            </li>
            <li>
              Request correction of your personal data: This enables you to have
              any incomplete or inaccurate data we hold about you corrected,
              though we may need to verify the accuracy of the new data you
              provide to us.
            </li>
            <li>
              Request erasure of your personal data: This enables you to ask us
              to delete or remove personal data where there is no good reason
              for us continuing to process it. You also have the right to ask us
              to delete or remove your personal data where you have successfully
              exercised your right to object to processing, where we may have
              processed your information unlawfully or where we are required to
              erase your personal data to comply with local law.
            </li>
            <li>
              Object to processing of your personal data: This is in situations
              where we are relying on a legitimate interest (or those of a third
              party) and there is something about your particular situation
              which makes you want to object to processing on this ground as you
              feel it impacts on your fundamental rights and freedoms.
            </li>
            <li>
              Request restriction of processing your personal data: This enables
              you to ask us to suspend the processing of your personal data in
              the following scenarios: (a) if you want us to establish the
              data's accuracy; (b) where our use of the data is unlawful but you
              do not want us to erase it; (c) where you need us to hold the data
              even if we no longer require it as you need it to establish,
              exercise or defend legal claims; or (d) you have objected to our
              use of your data but we need to verify whether we have overriding
              legitimate grounds to use it.
            </li>
            <li>
              Request transfer of your personal data: We will provide to you, or
              a third party you have chosen, your personal data in a structured,
              commonly used, machine-readable format. Note that this right only
              applies to automated information which you initially provided
              consent for us to use or where we used the information to perform
              a contract with you.
            </li>
            <li>
              Right to withdraw consent: If we are relying on consent to process
              your personal data, you have the right to withdraw that consent at
              any time. However, this will not affect the lawfulness of any
              processing carried out before you withdraw your consent.
            </li>
          </ul>
        </p>
        <p className="w-full">
          If you wish to exercise any of the rights set out above, please{" "}
          <Link to="/Contact" data-test="contact" className="underline">contact us</Link>.
        </p>
        <h1 className="text-2xl font-bold mt-3">Marketing Preferences</h1>
        <p className="w-full">
          We strive to provide you with choices regarding certain personal data
          uses, particularly around marketing and advertising. We may use your
          Identity, Contact, Technical, Usage, and Profile Data to form a view
          on what we think you may want or need, or what may be of interest to
          you. This is how we decide which products, services, and offers may be
          relevant for you.
        </p>
        <p className="w-full">
          You can ask us or third parties to stop sending you marketing messages
          at any time by following the opt-out links on any marketing message
          sent to you or by contacting us at any time.
        </p>

        <h1 className="text-2xl font-bold mt-3">
          Changes to the Privacy Policy and Your Duty to Inform Us of Changes
        </h1>
        <p className="w-full">
          This version was last updated on 28/07/2023 and historic versions can
          be obtained by contacting us.
        </p>
        <p className="w-full">
          It is important that the personal data we hold about you is accurate
          and current. Please keep us informed if your personal data changes
          during your relationship with us.
        </p>

        <h1 className="text-2xl font-bold mt-3">Cookies</h1>
        <p className="w-full">
          You can set your browser to refuse all or some browser cookies, or to
          alert you when websites set or access cookies. If you disable or
          refuse cookies, please note that some parts of this website may become
          inaccessible or not function properly. For more information about the
          cookies we use, please see our <Link to="/cookie-policy" className="underline">cookie policy</Link>.
        </p>

        <h1 className="text-2xl font-bold mt-3">Contact Us</h1>
        <p className="w-full">
          If you have any questions about this privacy policy or our privacy
          practices, please{" "}
          <Link to="/Contact" data-test="contact" className="underline">contact us</Link>.
        </p>
        <p className="w-full pb-4">
          You have the right to make a complaint at any time to the appropriate
          data protection authority in your country. We would, however,
          appreciate the chance to deal with your concerns before you approach
          the authority, so please contact us in the first instance.
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
